import { SidebarRoutes } from "Interface/sidebar";
import { routes } from "./routes";

export const sidebarRoutes: SidebarRoutes[] = [
  {
    title: "Dashboard",
    desc: "Get full information about current system status",
    icon: "/assets/svg/dashboard.svg",
    permission: ["users"],
    to: routes.index,
  },

  {
    title: "Products",
    desc: "Manage products",
    icon: "/assets/svg/product.svg",
    childRoutes: [routes.products, routes.addProduct],
    permission: ["purchases", "sells", "stock"],
    children: [
      {
        title: "List Products",
        desc: "List all products",
        icon: "/assets/svg/product.svg",
        to: routes.products,
      },
      {
        title: "Add Product",
        desc: "Add new product",
        icon: "/assets/svg/product-add.svg",
        to: routes.addProduct,
      },
    ],
  },
  {
    title: "Brands",
    desc: "Manage brands",
    icon: "/assets/svg/brand.svg",
    childRoutes: [routes.brands, routes.addBrand],
    permission: ["purchases", "sells", "stock", "brands"],
    children: [
      {
        title: "List Brands",
        desc: "List all brands",
        icon: "/assets/svg/brand.svg",
        to: routes.brands,
      },
      {
        title: "Add Brand",
        desc: "Add new brand",
        icon: "/assets/svg/add-brand.svg",
        to: routes.addBrand,
      },
    ],
  },
  {
    title: "Categories",
    desc: "Manage categories",
    icon: "/assets/svg/category.svg",
    childRoutes: [routes.categories, routes.addCategory],
    permission: ["purchases", "sells", "stock", "category"],
    children: [
      {
        title: "List Categories",
        desc: "List all categories",
        icon: "/assets/svg/category.svg",
        to: routes.categories,
      },
      {
        title: "Add Category",
        desc: "Add new category",
        icon: "/assets/svg/add-category.svg",
        to: routes.addCategory,
      },
    ],
  },
  {
    title: "Sales",
    desc: "Manage sales",
    icon: "/assets/svg/sales.svg",
    childRoutes: [
      routes.sales,
      routes.addSale,
      routes.salesReport,
      routes.salesReturnReport,
      routes.addSaleReturn,
    ],
    permission: ["sells"],
    children: [
      {
        title: "List Sales",
        desc: "List all sales",
        icon: "/assets/svg/sales.svg",
        to: routes.sales,
      },

      {
        title: "Add Sale",
        desc: "Add new sale",
        icon: "/assets/svg/add-sales.svg",
        to: routes.addSale,
      },
      {
        title: "Add Sales Return",
        desc: "Add new sales return",
        icon: "/assets/svg/add-sales.svg",
        to: routes.addSaleReturn,
      },
      {
        title: "Sales Report",
        desc: "All sales reports",
        icon: "/assets/svg/sales-report.svg",
        to: routes.salesReport,
      },
      {
        title: "Sales Return Report",
        desc: "All sales reports",
        icon: "/assets/svg/sales-return-report.svg",
        to: routes.salesReturnReport,
      },
    ],
  },
  {
    title: "Purchases",
    desc: "Manage purchases",
    icon: "/assets/svg/purchase.svg",
    childRoutes: [
      routes.purchases,
      routes.addPurchase,
      routes.purchaseReport,
      routes.addPurchaseReturn,
      routes.purchaseReturnReport,
    ],
    permission: ["purchases"],
    children: [
      {
        title: "List Purchases",
        desc: "List all purchases",
        icon: "/assets/svg/purchase.svg",
        to: routes.purchases,
      },
      {
        title: "Add Purchase",
        desc: "Add new purchase",
        icon: "/assets/svg/add-purchase.svg",
        to: routes.addPurchase,
      },
      {
        title: "Add Purchase Return",
        desc: "Add new purchase return",
        icon: "/assets/svg/add-purchase.svg",
        to: routes.addPurchaseReturn,
      },
      {
        title: "Purchase Report",
        desc: "Add new purchase",
        icon: "/assets/svg/purchase-report.svg",
        to: routes.purchaseReport,
      },
      {
        title: "Purchase Return Report",
        desc: "Add new purchase",
        icon: "/assets/svg/purchase-return-report.svg",
        to: routes.purchaseReturnReport,
      },
    ],
  },
  {
    title: "Suppliers",
    desc: "Manage suppliers",
    icon: "/assets/svg/supplier.svg",
    childRoutes: [routes.suppliers, routes.addSupplier],
    permission: ["purchases", "suppliers"],
    children: [
      {
        title: "List Suppliers",
        desc: "List all suppliers",
        icon: "/assets/svg/supplier.svg",
        to: routes.suppliers,
      },
      {
        title: "Add Supplier",
        desc: "Add new supplier",
        icon: "/assets/svg/add-supplier.svg",
        to: routes.addSupplier,
      },
    ],
  },
  {
    title: "Customers",
    desc: "Manage customers",
    icon: "/assets/svg/customer.svg",
    childRoutes: [routes.customers, routes.addCustomer],
    permission: ["sells", "customers"],
    children: [
      {
        title: "List Customers",
        desc: "List all customers",
        icon: "/assets/svg/customer.svg",
        to: routes.customers,
      },
      {
        title: "Add Customer",
        desc: "Add new customer",
        icon: "/assets/svg/add-customer.svg",
        to: routes.addCustomer,
      },
    ],
  },
  {
    title: "Users",
    desc: "Manage users",
    icon: "/assets/svg/user.svg",
    childRoutes: [routes.users, routes.addUser],
    permission: ["users"],
    children: [
      {
        title: "List Users",
        desc: "List all users",
        icon: "/assets/svg/user.svg",
        to: routes.users,
      },
      {
        title: "Add User",
        desc: "Add new user",
        icon: "/assets/svg/add-user.svg",
        to: routes.addUser,
      },
    ],
  },
  {
    title: "Audits",
    desc: "Audit trails and logs",
    icon: "/assets/svg/audits.svg",
    childRoutes: [routes.materializedView],
    permission: ["users"],
    children: [
      {
        title: "Materialized View",
        desc: "Materialized View",
        icon: "/assets/svg/audits.svg",
        to: routes.materializedView,
      },
    ],
  },

  {
    title: "Banks",
    desc: "Manage banks",
    icon: "/assets/svg/reports.svg",
    childRoutes: [routes.banks, routes.addBank],
    permission: ["users"],
    children: [
      {
        title: "List Banks",
        desc: "List all banks",
        icon: "/assets/svg/reports.svg",
        to: routes.banks,
      },
      {
        title: "Add Bank",
        desc: "Add new bank",
        icon: "/assets/svg/reports.svg",
        to: routes.addBank,
      },
    ],
  },

  {
    title: "Reports",
    desc: "Manage accounting reports",
    icon: "/assets/svg/reports.svg",
    childRoutes: [
      routes.journalReport,
      routes.chartOfAccounts,
      routes.chartOfAccountsType,
      routes.balanceSheet,
      routes.profitLossAccount,
    ],
    permission: ["users"],
    children: [
      {
        title: "Journal Report",
        desc: "Journal Report",
        icon: "/assets/svg/reports.svg",
        to: routes.journalReport,
      },
      {
        title: "Chart of Accounts",
        desc: "Chart of Accounts",
        icon: "/assets/svg/reports.svg",
        to: routes.chartOfAccounts,
      },
      {
        title: "Chart of Accounts Type",
        desc: "Chart of Accounts Type",
        icon: "/assets/svg/reports.svg",
        to: routes.chartOfAccountsType,
      },
      {
        title: "Balance Sheet",
        desc: "Balance Sheet",
        icon: "/assets/svg/reports.svg",
        to: routes.balanceSheet,
      },
      {
        title: "Profit Loss Account",
        desc: "Profit Loss Account",
        icon: "/assets/svg/reports.svg",
        to: routes.profitLossAccount,
      },
    ],
  },
  {
    title: "Backup",
    desc: "Backup and restore database",
    icon: "/assets/svg/backup.svg",
    permission: ["users"],
    to: routes.backup,
  },
  {
    title: "Action",
    desc: "Manage actions",
    icon: "/assets/svg/action.svg",
    permission: ["users"],
    to: routes.actions,
  },
  {
    title: "Help",
    desc: "Issues and help",
    icon: "/assets/svg/help.svg",
    childRoutes: [routes.help, routes.addissue],
    permission: ["users"],
    children: [
      {
        title: "Issue List",
        desc: "Issue List",
        icon: "/assets/svg/help.svg",
        to: routes.help,
      },
      {
        title: "Add Issue",
        desc: "Add Issue",
        icon: "/assets/svg/add-issue.svg",
        to: routes.addissue,
      },
    ],
  },
];
